import type { ReactNode } from 'react'
import { Image } from '@/components/ui/image'
import type { LogoAsset } from '@/tenants/tenant-logos'

interface TenantLogoProps {
	/** Logo asset from the tenant config. An inline SVG component or an image URL. */
	asset: LogoAsset | undefined
	className?: string
	alt?: string
	/** Rendered when `asset` is undefined or an image URL fails to load. */
	fallback?: ReactNode
}

/**
 * Renders a tenant logo. Inline SVG components are tinted via `currentColor`
 * (set `text-*` on `className`); string URLs render as an `<img>`.
 */
export function TenantLogo({ asset, className, alt, fallback = null }: TenantLogoProps) {
	if (!asset) {
		return <>{fallback}</>
	}

	if (typeof asset !== 'string') {
		const Svg = asset
		return <Svg className={className} />
	}

	return <Image src={asset} alt={alt} className={className} fallback={fallback} />
}
